var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRoadmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.3373C15 10.4373 14.9527 10.5309 14.8709 10.5903L12.9817 11.9426C12.9281 11.98 12.8621 12.0019 12.7958 12.0019H7.82119V14.6878C7.82119 14.8626 7.68266 15 7.50641 15C7.33328 15 7.19163 14.8626 7.19163 14.6878L7.19146 7.49196H2.20415C2.1381 7.49196 2.07188 7.47317 2.01835 7.43265L0.129142 6.08032C0.0472755 6.02411 0 5.92723 0 5.8274C0 5.72741 0.0472755 5.63379 0.129142 5.57448L2.01835 4.22215C2.07188 4.18473 2.13793 4.16284 2.20415 4.16284H7.19146V2.67311H5.61721C5.44409 2.67311 5.30243 2.5326 5.30243 2.36088V0.312226C5.30243 0.140508 5.44409 0 5.61721 0H9.39563C9.57188 0 9.71041 0.140512 9.71041 0.312226V2.36088C9.71041 2.5326 9.57188 2.67311 9.39563 2.67311H7.82138V8.67227H12.796C12.8621 8.67227 12.9283 8.69106 12.9818 8.72848L14.871 10.0839C14.9526 10.1401 14.9999 10.2339 14.9999 10.337L15 10.3373Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoadmap);
export default __webpack_public_path__ + "static/media/icon-roadmap.2f96d1c86f406ecaf7eb087025c68b8f.svg";
export { ForwardRef as ReactComponent };